import { UploadCloud, FileText, CheckCircle2 } from "lucide-react";

export default function UploadFilesStep({ formData, updateField }) {
  const handleFiles = (e) => {
    const chosen = Array.from(e.target.files).map((f) => ({
      name: f.name,
      size: `${(f.size / 1024 / 1024).toFixed(1)} MB`,
    }));
    updateField("files", [...formData.files, ...chosen]);
  };

  return (
    <div>
      <label className="block border-2 border-dashed border-indigo-200 bg-indigo-50/40 rounded-2xl px-6 py-14 text-center cursor-pointer hover:bg-indigo-50 transition">
        <input type="file" multiple className="hidden" onChange={handleFiles} />
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mx-auto mb-5">
          <UploadCloud className="w-6 h-6 text-white" />
        </div>
        <p className="font-bold text-gray-900 mb-1">
          Drop CAD, STL, STEP, IGES, DWG, DXF or PDF
        </p>
        <p className="text-sm text-gray-500 mb-5">
          or click to browse from your computer · max 500 MB
        </p>
        <span className="inline-block bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-sm font-semibold px-6 py-2.5 rounded-xl">
          Choose Files
        </span>
      </label>

      {formData.files.length > 0 && (
        <div className="mt-6 space-y-3">
          {formData.files.map((file, i) => (
            <div
              key={i}
              className="flex items-center justify-between border border-gray-100 rounded-xl px-4 py-3"
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center">
                  <FileText className="w-4 h-4 text-blue-500" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">{file.name}</p>
                  <p className="text-xs text-gray-500">{file.size} · Uploaded</p>
                </div>
              </div>
              <CheckCircle2 className="w-5 h-5 text-green-500" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}